const ErrorHandlingUrls = {
  clientLogs: "/api/ClientLogs",
};
export default ErrorHandlingUrls;
